import { render, staticRenderFns } from "./LibrosBolsa.vue?vue&type=template&id=f47eb932&scoped=true&"
import script from "./LibrosBolsa.vue?vue&type=script&lang=js&"
export * from "./LibrosBolsa.vue?vue&type=script&lang=js&"
import style0 from "./LibrosBolsa.vue?vue&type=style&index=0&id=f47eb932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47eb932",
  null
  
)

export default component.exports